import  ActionType  from './ActionType';
import { INotification } from '../components/mike-notification-list';

export const initialNotificationState: NotificationState = {
  notifications: localStorage.getItem('notification')
    ? JSON.parse(localStorage.getItem('notification'))
    : {},
  showNotificationDot: false,
};

export interface NotificationState {
  notifications: INotification[];
  showNotificationDot: boolean;
}

export interface NotificationAction {
  type: ActionType.ADD_NOTIFICATION | ActionType.HIDE_NOTIFICATION_DOT;
  data: { projectId: string; notification: INotification };
}

export const notificationReducer = (state: NotificationState, action: NotificationAction) => {
  switch (action.type) {
    case ActionType.ADD_NOTIFICATION:
    { 
      const existingNotifications = state.notifications;
      const { projectId, notification } = action.data;
      if (!existingNotifications[projectId]) {
        existingNotifications[projectId] = new Array<INotification>();
      }
      existingNotifications[projectId].push(notification);
      localStorage.setItem('notification', JSON.stringify(existingNotifications));
      return { ...state, notifications: existingNotifications, showNotificationDot: true }; 
    }
    case ActionType.HIDE_NOTIFICATION_DOT:
      return { ...state, showNotificationDot: false };
    default:
      return state;
  }
};
